import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { ErrorToast, SuccessToast } from "../../shared/toasters/toasters";
import { useTranslation } from "react-i18next";
import { AdminEventSummaryCatService } from "./service";
import { CreateForm } from "./components/CreateForm";
import { multipartFormData } from "../../helpers/api.services";
import { EVENT_SUMMARY_CAT_URL } from "../../helpers/api.routes";
import DraggableBootstrapTable from "../../shared/components/draggableList/Draggable";

export const AdminEventSummaryCategory = () => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const [selectedPrompt, setSelectedPrompt] = useState<any>();
  const [isMenuOpened, setIsMenuOpened] = useState(false);
  const [triggerUpdate, setTriggerUpdate] = useState(false);
  const [state, setState] = useState<any>({ isActive: true });
  const [image, setImage] = useState<File>();
  const [list, setList] = useState<any>(undefined);

  const deleteHandler = () => {
    selectedPrompt?.id &&
      AdminEventSummaryCatService.delete(selectedPrompt?.id)
        .then((response) => {
          if (response?.status === "success") {
            SuccessToast(t(`event_sum_cat.successfully_deleted`));
            setTriggerUpdate((prev: boolean) => !prev);
          }
        })
        .catch((error) => ErrorToast(error));
  };

  const editHandler = (brandId: number) => {
    setIsMenuOpened(true);
    AdminEventSummaryCatService.getSingle(brandId)
      .then((response) => {
        const { data } = response;

        setState(data);
        window.scrollTo(0, 0);
      })
      .catch((error) => ErrorToast(error));
  };
  const updatePosition = (newList: any) => {
    const newListUpdated = newList?.map((item: any) => item.id);
    AdminEventSummaryCatService.updatePosition({ ids: newListUpdated });
  };
  const submitHandler = () => {
    if (state?.id) {
      multipartFormData(
        image,
        `${EVENT_SUMMARY_CAT_URL}/${state?.id}`,
        JSON.stringify({
          ...state,
        }),
        "post",
      )
        .then((response) => {
          SuccessToast(t(`event_sum_cat.successfully_updated`));
          setIsMenuOpened(false);
          setTriggerUpdate(!triggerUpdate);
          setState({});
        })
        .catch((error) => ErrorToast(error));
    } else {
      multipartFormData(
        image,
        `${EVENT_SUMMARY_CAT_URL}`,
        JSON.stringify({
          ...state,
        }),
        "post",
      )
        .then((response) => {
          SuccessToast(t(`event_sum_cat.successfully_created`));
          setIsMenuOpened(false);
          setTriggerUpdate(!triggerUpdate);
          setState({});
        })
        .catch((error) => ErrorToast(error));
    }
  };
  useEffect(() => {
    AdminEventSummaryCatService.getAll({ perPage: 0, page: 1 })
      .then((response) => {
        const { data } = response;
        setList(data?.items);
      })
      .catch((error) => ErrorToast(error));
  }, [triggerUpdate]);

  return (
    <>
      {!isMenuOpened && (
        <div className="col-12">
          <div className="card">
            <div className="card-body d-flex align-items-center justify-content-between">
              <h4 className="card-title mg-b-0">
                {t("event_sum_cat.create_new_event")}
              </h4>
              <button
                className="btn btn-primary"
                onClick={() => setIsMenuOpened(true)}
              >
                {t("global.add")}
              </button>
            </div>
          </div>
        </div>
      )}

      {isMenuOpened && (
        <div className="col-12">
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              submitHandler();
            }}
          >
            <CreateForm
              setImage={setImage}
              setIsMenuOpened={setIsMenuOpened}
              state={state}
              setState={setState}
            />
          </Form>
        </div>
      )}
      <div className="col-12">
        <DraggableBootstrapTable
          list={list}
          setList={setList}
          headers={["id", "name"]}
          title="category"
          onEdit={editHandler}
          selectedPrompt={selectedPrompt}
          setSelectedPrompt={setSelectedPrompt}
          handleShow={handleShow}
          show={show}
          setShow={setShow}
          deleteHandler={deleteHandler}
          updatePosition={updatePosition}
        />
      </div>
    </>
  );
};
